import styled           from 'styled-components';

import { themeColors,
         themeTypos,
         Typo,
         typoAsCSS    } from 'src/providers/theme/shared';



type InputPhoneLookAndFeel = {
  typo: Typo;
  normalColor: string;
  disabledColor: string;
};

const inputphone_h48light: InputPhoneLookAndFeel = {
  typo: themeTypos.GRTSKREG_W400_S16_LH20,
  normalColor: themeColors.PrimaryBlack,
  disabledColor: themeColors.SecondaryGray4,
};

export type InputPhoneVariants = 'h48light';

export const inputphone_variants: Map<InputPhoneVariants, InputPhoneLookAndFeel> = 
  new Map<InputPhoneVariants, InputPhoneLookAndFeel>([
    ['h48light', inputphone_h48light],
  ]);

export const Input = styled.input<{
  isDisabled: boolean;
  lookAndFeel: InputPhoneLookAndFeel;
}>`
  width: 1px;
  flex-grow: 2;

  ${(args) => typoAsCSS(args.lookAndFeel.typo)}
  letter-spacing: 0.2em;

  color: ${(args) => args.isDisabled ? args.lookAndFeel.disabledColor : args.lookAndFeel.normalColor};
`;
